import { TILE } from '../sim/constants';

/*
 * ההיטל — המקום היחיד בפרויקט שיודע איך קואורדינטת עולם הופכת לפיקסל.
 *
 * **הסימולציה לא יודעת שקיים מסך.** היא עובדת ביחידות עולם (TILE ליחידת אריח),
 * וכל מה שמתחת נוגע רק בתצוגה. לכן מעבר להיטל איזומטרי בעתיד הוא שינוי בשתי
 * הפונקציות כאן ובמפתח מיון העומק — ולא נגיעה במצב המשחק.
 *
 * כרגע: אורתוגונלי (מבט-על). איזומטרי יהיה
 *   sx = (wx - wy) * k        sy = (wx + wy) * k / 2
 * ואז screenToWorld הוא היפוך המטריצה הזו.
 */

export interface Camera {
    /** מרכז המצלמה, ביחידות עולם. */
    readonly x: number;
    readonly y: number;
    /** פיקסלי CSS לאריח. */
    readonly zoom: number;
}

export interface Viewport {
    /** רוחב בפיקסלי CSS (לא פיקסלי מכשיר). */
    readonly width: number;
    readonly height: number;
}

export function worldToScreenX(worldX: number, cam: Camera, vp: Viewport): number {
    return ((worldX - cam.x) / TILE) * cam.zoom + vp.width / 2;
}

export function worldToScreenY(worldY: number, cam: Camera, vp: Viewport): number {
    return ((worldY - cam.y) / TILE) * cam.zoom + vp.height / 2;
}

export function screenToWorldX(screenX: number, cam: Camera, vp: Viewport): number {
    return ((screenX - vp.width / 2) / cam.zoom) * TILE + cam.x;
}

export function screenToWorldY(screenY: number, cam: Camera, vp: Viewport): number {
    return ((screenY - vp.height / 2) / cam.zoom) * TILE + cam.y;
}

/** מרכז האריח ביחידות עולם. יחידות ממוקמות ביחידות עולם, לא באריחים. */
export function tileCenterWorld(tile: number): number {
    return tile * TILE + TILE / 2;
}

export function worldToTile(world: number): number {
    return Math.floor(world / TILE);
}

/** תחום האריחים הנראה כרגע, כולל שוליים לציור חלקי בקצוות. */
export interface TileBounds {
    readonly minX: number;
    readonly minY: number;
    readonly maxX: number;
    readonly maxY: number;
}

export function visibleTiles(
    cam: Camera,
    vp: Viewport,
    mapW: number,
    mapH: number,
    margin = 1,
): TileBounds {
    const halfTilesX = vp.width / 2 / cam.zoom;
    const halfTilesY = vp.height / 2 / cam.zoom;
    const centerTileX = cam.x / TILE;
    const centerTileY = cam.y / TILE;

    return {
        minX: Math.max(0, Math.floor(centerTileX - halfTilesX) - margin),
        minY: Math.max(0, Math.floor(centerTileY - halfTilesY) - margin),
        maxX: Math.min(mapW - 1, Math.ceil(centerTileX + halfTilesX) + margin),
        maxY: Math.min(mapH - 1, Math.ceil(centerTileY + halfTilesY) + margin),
    };
}
